import * as React from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import './videoPlayerTaskModule.scss';
import { RouteComponentProps } from 'react-router-dom';
import { app, dialog } from "@microsoft/teams-js";
import { TFunction } from "i18next";


export interface IListItem {
    header: string,
    media: JSX.Element,
}

export interface IAction {
    title: string,
    link: string
}

export interface IVideoState {
    videoUrl?: string;
    videoType?: string
}

interface videoPlayerTaskModuleProps extends RouteComponentProps, WithTranslation { }

class videoPlayerTaskModule extends React.Component<videoPlayerTaskModuleProps, IVideoState> {
    readonly localize: TFunction;
    private initMessage = {
        id: "",
        title: "",
        actions: [],
    };

    private card: any;

    constructor(props: videoPlayerTaskModuleProps) {
        super(props);

        this.localize = this.props.t;

        /* this.card = getInitAdaptiveCard(this.props.t);*/

        //this.state = {
        //    videoUrl: "",
        //};
        let query = this.GetQueryParameters();

        this.state = {
            videoUrl: query["videoUrl"],
            videoType: query["videoType"],
        };
        //let params = this.props.match.params;
        //if ('id' in params) {
        //    let videoId = params['id'];
        //    let type = params['type'];
        //    console.log(decodeURIComponent(videoId));
        //    console.log(decodeURIComponent(type));
        //    this.state = {
        //        videoUrl: decodeURIComponent(videoId),
        //        videoType: decodeURIComponent(type),
        //    };
        //}
    }

    private GetQueryParameters = () => {
        let queryParams: any = {};
        window.location.search.substring(1).split("&").forEach(function (item) {
            let s = item.split("="),
                k = s[0],
                v = s[1] && decodeURIComponent(s[1]);
            queryParams[k] = v;
        });
        return queryParams;
    }


    public componentDidMount() {
        //let params = this.props.match.params;
        app.initialize().then(() => {
            app.getContext().then((context) => {
                //this.setState({
                //    teamId: context.teamId,
                //});
            });
        });


    }

    public render(): JSX.Element {
        return (
            <div className="videoModule">
                <div className="formContainer">
                    {(this.state.videoType == "youtube" || this.state.videoType == "vimeo") && <iframe id="player" allowFullScreen
                        src={this.state.videoUrl} style={{ margin: 0, height: "100%", width: "100%" }}
                        frameBorder="0"></iframe>}
                    {!(this.state.videoType == "youtube" || this.state.videoType == "vimeo") &&
                        <video width="100%" height="100%" controls>
                            <source src={this.state.videoUrl} type={this.state.videoType} />
                            Your browser does not support the video tag.
                        </video>}
                </div>
            </div>
        );
    }

    private onClose = () => {
        dialog.url.submit();
    }
}

const videoPlayerTaskModuleWithTranslation = withTranslation()(videoPlayerTaskModule);
export default videoPlayerTaskModuleWithTranslation;